import { render } from "./Snippets.vue?vue&type=template&id=46073773&bindings={\"sort\":\"setup\",\"addFile\":\"setup\",\"snippets\":\"setup\",\"updateFile\":\"setup\",\"formatTime\":\"setup\",\"sortOptions\":\"setup\",\"activeFilter\":\"setup\"}"
import script from "./Snippets.vue?vue&type=script&lang=js"
export * from "./Snippets.vue?vue&type=script&lang=js"

import "./Snippets.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script